import { commitMutation, graphql } from "react-relay";
import environment from "../Environment";

const mutation = graphql`
    mutation VerifyTokenMutation($token: String!) {
        verifyToken(token: $token) {
            payload
        }
    }
`;

export default (token, callback) => {
    const variables = {
        token: token,
    };

    commitMutation(environment, {
        mutation,
        variables,
        onCompleted: (response, errors) => {
            if (response.verifyToken != null) {
                callback(true);
            } else {
                callback(false);
            }
        },
        onError: (err) => console.error(err),
    });
};
